export enum ERecordPageType {
    TopMenu,
    UserDetail,
    Hierarchy
}